import React, { FC, useCallback, useMemo, useRef, useState } from 'react'
import {
  ComponentConsumerProps,
  ComponentRendering,
  isEditorActive,
  Placeholder,
  RichText,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react'
import { AccordionMultiplePDFProps } from './types/AccordionMultiplePDF.types'
import '../AccordionList/index.scss'

const AccordionMultiplePDF: FC<ComponentConsumerProps & AccordionMultiplePDFProps> = ({
  fields: { List } = { List: [] },
  rendering,
  sitecoreContext,
}) => {
  const isExperienceEditor = isEditorActive();

  const shouldOpenAll: boolean = useMemo(
    () => isExperienceEditor || sitecoreContext?.pageEditing,
    [sitecoreContext]
  )

  const ItemAccordion: FC<{ index: number; title: string }> = useMemo(() => {
    return function Component({ index, title }) {
      const [isOpen, setIsOpen] = useState(shouldOpenAll)

      const handleAccordionClick = useCallback(() => {
        setIsOpen((prevValue) => !prevValue)
      }, [])

      const accordionRef = useRef<HTMLDivElement>(null);

      const Component: FC = useMemo(() => {
        return function Component() {
          return (
            <div className="download__accordion__media">
              <div
                className="download__accordion__header__overlay"
                onClick={handleAccordionClick}
              >
                <div
                  className={`download__accordion__header__overlay__arrow ${
                    isOpen
                      ? 'download__accordion__header__overlay__arrow--reverse'
                      : ''
                  }`}
                />
              </div>

              <div className="rte-event-list-right">
                <div className="rte-event-list-header-wrapper">
                  <div
                    className={`rte-event-list-header ${
                      index % 2 === 0 ? 'even' : 'odd'
                    }`}
                  >
                    <RichText
                      field={{
                        value:
                          title.length > 0 ? title : '! please add title !',
                      }}
                      className="download__accordion__accordion_title"
                    />

                    <Placeholder
                      name={`jss-list${index}`}
                      rendering={rendering as ComponentRendering }
                    />
                  </div>
                </div>
              </div>
            </div>
          )
        }
      }, [isOpen, handleAccordionClick])

      return (
        <div
          ref={accordionRef}
          style={{
            maxHeight: isOpen ? accordionRef?.current?.scrollHeight : 111,
            overflow: 'hidden',
            transition: 'max-height 0.5s',
            transitionTimingFunction: 'ease-in-out',
          }}
        >
          <Component />
        </div>
      )
    }
  }, [rendering, shouldOpenAll])

  return (
    <div>
      <div className="rte-event">
        {List.map(({ fields: { Title } }, index: number) => (
          <div
            key={index}
            className={
              index % 2
                ? 'rte-event-list rte-event-listBKB'
                : 'rte-event-list rte-event-listBKA'
            }
          >
            <ItemAccordion index={index} title={Title?.value ?? ''} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default withSitecoreContext()(AccordionMultiplePDF)
